<template>
  <!-- 大屏页面layout -->
  <div class="base_container">
    <el-container class="is-vertical">
      <el-main
        :class="[
          !showHeaderCollapse && !showFootCollapse
            ? 'collapseMain'
            : !showHeaderCollapse && showFootCollapse
            ? 'collapseHead'
            : showHeaderCollapse && !showFootCollapse
            ? 'collapseFoot'
            : '',
        ]"
      >
        <m-header v-if="showHeaderCollapse"></m-header>
        <div
          class="mainMonitor"
          :class="[
            showHelmetTable ? 'showHelmetTable' : '',
            !showHeaderCollapse && !showFootCollapse
              ? 'allMain'
              : !showHeaderCollapse && showFootCollapse
              ? 'hidencollapseHead'
              : showHeaderCollapse && !showFootCollapse
              ? 'hidencollapseFoot'
              : '',
          ]"
        >
          <div id="mapNew" style="height:100%;width:100%;position: relative">
            <div class="map-switch">
              <div :class="{ active: mapType === 'street' }" @click="switchMapType('street')">{{ $t('mapB') }}</div>
              <div :class="{ active: mapType === 'satellite' }" @click="switchMapType('satellite')">
                {{ $t('satellite') }}
              </div>
            </div>
            <!-- 轨迹控制器 -->
            <TrackController
              v-if="showTrackController"
              :showTrackVideo="showTrackVideo"
              :item="currentItem"
              :listTrack.sync="listTrack"
              :listTrackIndex.sync="listTrackIndex"
              :trailQuery="trailQuery"
              :trailTotal="trailTotal"
              :trailPageNum="trailPageNum"
              newStyle
              @closeTrackController="closeTrackController"
              @drawTrackStart="drawTrackStart"
              @openTrackVideo="openTrackVideo"
            ></TrackController>
            <!-- 轨迹对应视频 -->
            <div v-show="showVideo" class="trail-video-box" :style="{ width: '450px', height: '300px' }">
              <TrailVideotape
                :videoSrc="trailVideoData"
                :videoShow.sync="showVideo"
                :videoSecond="videoSecond"
                @trailVideo="trailVideo"
                :index="0"
              ></TrailVideotape>
            </div>
            <!-- 子页面容器 -->
            <div class="mainContain" :class="{ bgMainContain: bgMainContain }">
              <router-view
                :commanditem="currentItem"
                :currentItem.sync="currentItem"
                @playTrail="playTrail"
                @closePopup="closePopup"
                :trackPopupInfo="trackPopupInfo"
                @changeTableData="changeTableData"
              ></router-view>
            </div>
          </div>
          <div class="maskbg" v-show="isPlayTrack"></div>
          <!-- 实时视频全局 -->
          <div class="base-box" v-if="showRealeVideo">
            <vue-draggable-resizable
              :w="520"
              :h="350"
              :x="0"
              :y="0"
              :min-width="350"
              :min-height="250"
              :parent="false"
              :grid="[10, 10]"
              id="amplifyVideo"
              class-name="dragging1"
              @dragging="onDrag"
              @resizing="onResize"
              :draggable="allowDrag"
            >
              <div class="reaVideo-box">
                <RealVideo
                  v-if="rtcType === 'trtc'"
                  :device.sync="realVideoData"
                  :currentItem="formatDataItem"
                  :deviceName="formatDataItem.deviceName"
                  :allowClick="allowClick"
                  ref="realVideoContr"
                ></RealVideo>
                <RealVideoSrs
                  v-else-if="rtcType === 'srs'"
                  :device.sync="realVideoData"
                  :currentItem="formatDataItem"
                  :deviceName="formatDataItem.deviceName"
                  :allowClick="allowClick"
                  ref="realVideoContr"
                ></RealVideoSrs>
                <RealVideoMediasoup
                  v-else-if="rtcType === 'mediasoup'"
                  :device.sync="realVideoData"
                  :currentItem="formatDataItem"
                  :deviceName="formatDataItem.deviceName"
                  :allowClick="allowClick"
                  ref="realVideoContr"
                ></RealVideoMediasoup>
              </div>
            </vue-draggable-resizable>
          </div>
        </div>

        <!-- 地图弹框容器 currentItem.specType === 0 ? 'jls-popup'-->
        <div
          id="popup"
          class="ol-popup"
          :class="[currentItem.specType === 0 ? 'ps-popup' : currentItem.specType === 4 ? 'ps-popup' : 'gk3-popup']"
          v-if="!currentItem.noBindDevice"
        >
          <i id="popup-closer" class="ol-popup-closer" @click="closePopup"></i>
          <div id="popup-content" style="margin-bottom: 15px;">
            <div
              :class="[
                currentItem.specType === 0
                  ? 'jlshelmet'
                  : currentItem.onlineStatus === '0'
                  ? 'helmetStatusOff'
                  : 'helmetStatus',
              ]"
            >
              <!-- 轨迹关键点 信息弹框 -->
              <div v-if="trackPopupInfo.serialNumber || trackPopupInfo.userName">
                <TrackPopup :trackPopupInfo="trackPopupInfo"></TrackPopup>
              </div>
              <!-- 定位 信息弹框 -->
              <div v-else-if="currentItem && currentItem.specType === 4">
                <div class="titleblock">
                  <span class="user"> {{ currentItem.userName }}-{{ currentItem.deviceName }} </span>
                  <span class="model" v-if="currentItem.onlineStatus !== '0' && helmetItemInfo.pattern === 3"
                    >「隐私模式」</span
                  >
                </div>
                <div class="content black">
                  <div>
                    <div v-if="currentItem.positionName">{{ $t('positionB') }}：{{ currentItem.positionName }}</div>
                    <div class="mt5">{{ $t('time') }}：{{ currentItem.timestamp }}</div>
                    <div class="mt5">{{ $t('unreadAlarm') }}：{{ tableData.length }}</div>
                  </div>
                  <div class="contend-right">
                    <div class="flexColumn">
                      <img
                        :src="
                          require(currentItem.onlineStatus === '1'
                            ? sateStatus.chargStatus === 1
                              ? '@/icon/charge_off.png'
                              : '@/icon/charge_on.png'
                            : '@/icon/charge_off.png')
                        "
                        alt=""
                      />
                      <span class="mt2">{{ $t('chargingState') }}</span>
                    </div>
                    <div class="flexColumn">
                      <img
                        :src="
                          require(currentItem.onlineStatus === '0'
                            ? '@/icon/new-command/ic_weixing2.png'
                            : '@/icon/new-command/ic_weixing1.png')
                        "
                        alt=""
                      />
                      <span class="mt2">卫星</span>
                      <span>{{ sateStatus.cidNum }}</span>
                    </div>

                    <div class="flexColumn">
                      <img :src="signalIcon" alt="" />
                      <span class="mt2">信号</span>
                      <span>
                        <span>4g</span>
                      </span>
                    </div>
                    <div class="flexColumn">
                      <img :src="powerIcon" alt="" />
                      <span class="mt2">{{ $t('Power') }}</span>
                      <span>{{ sateStatus.freeBattery }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 智能帽衬 信息弹框 -->
              <div v-else-if="currentItem && currentItem.specType !== 0">
                <div class="titleblock">
                  <span class="user"> {{ currentItem.userName }}-{{ currentItem.deviceName }} </span>
                  <span class="model" v-if="currentItem.onlineStatus !== '0' && diveMode">「隐私模式」</span>
                </div>
                <div class="content black">
                  <div v-if="currentItem.positionName">{{ $t('positionB') }}：{{ currentItem.positionName }}</div>
                  <div class="time-alarm">
                    <div class="mt5 item-time">{{ $t('time') }}：{{ currentItem.timestamp }}</div>
                    <div class="mt5 item-alarm">{{ $t('unreadAlarm') }}：{{ tableData.length }}</div>
                  </div>
                  <!-- ih6心率血样图表 -->
                  <HealthChart :helmetdata="currentItem" v-if="currentItem.showHealth"></HealthChart>
                  <div class="contend-right">
                    <div class="flexColumn">
                      <img :src="wifiIcon" alt="" />
                      <span class="mt2">{{ $t('signal') }}</span>
                      <span v-if="currentItem.onlineStatus === '0'">
                        <span v-if="wifi">wifi</span>
                        <span v-else>mobile</span>
                      </span>
                      <span v-else>
                        <span v-if="onlineNetwork">wifi</span>
                        <span v-else>mobile</span>
                      </span>
                    </div>
                    <div class="flexColumn">
                      <img :src="powerIcon" alt="" />
                      <span class="mt2">{{ $t('Power') }}</span>
                      <span>{{ battery }}</span>
                    </div>
                    <div class="flexColumn" v-if="envTemp !== '-'">
                      <img :src="tempIcon" alt="" />
                      <span class="mt2">{{ $t('temperature') }}</span>
                      <span>{{ envTemp }}</span>
                    </div>
                    <div class="flexColumn" v-if="pressure !== '-'">
                      <img :src="pressureIcon" alt="" />
                      <span class="mt2">{{ $t('pressure') }}</span>
                      <span>{{ pressure }}</span>
                      <span>(kPa)</span>
                    </div>
                    <!-- 脱帽状态 -->
                    <div class="flexColumn" v-if="currentHelmetStatus.wearing === true">
                      <img :src="wearingIcon" alt="" />
                      <span class="mt2">{{ $t('wearingHat') }}</span>
                    </div>
                    <div class="flexColumn" v-else-if="currentHelmetStatus.wearing === false">
                      <img :src="wearingOffIcon" alt="" />
                      <span class="mt2">{{ $t('raiseTheHat') }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 其它头盔 信息弹框 -->
              <div v-else-if="currentItem">
                <NewJlsStatusPan :JlsTrailVisible.sync="JlsTrailVisible" :helmetdata="currentItem"></NewJlsStatusPan>
              </div>
            </div>
          </div>
        </div>

        <!-- 底部头盔列表 -->
        <HelmetList @choosePointOpen="choosePointOpen" />
      </el-main>
      <m-footer v-if="showFootCollapse"></m-footer>
      <!-- 全局语音对讲 -->
      <audio ref="newAudio" id="walkieDom" autoplay></audio>
      <div class="close-yuyin" v-drag v-if="showWaike">
        <p>
          <img
            :src="require(isDefaultTheme ? '@/icon/voice/voiceing.gif' : '@/icon/voice/waiking.gif')"
            alt=""
            class="voice-icon"
          />
          <span v-show="waikIngInfo.groupName"> </span>{{ $t('voiceCallProgress') }}
          <span class="dot">...</span>
        </p>
        <span class="close-btn" @click="handleWaike">{{ $t('closeN') }}</span>
      </div>
    </el-container>
    <!-- 室内地图弹窗 -->
    <el-dialog
      :visible.sync="indoorMapVisible"
      :append-to-body="true"
      :close-on-click-modal="false"
      class="indoor-map-container"
    >
      <IndoorMap v-if="indoorMapVisible"></IndoorMap>
      <div slot="title" class="record">
        <div class="title_box">
          <div class="new_title">室内地图展示</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 依赖组件
import MHeader from '@/components/new-header/Index.vue'
import MFooter from '@/components/new-footer/Index.vue'
import TrackController from '@/views/monitor/index/TrackController.vue'
import TrailVideotape from '@/views/monitor/index/TrailVideotape.vue'
import IndoorMap from '@/components/indoorMap/Index.vue'
import { loadIndoorMapPoi } from '@/common/indoorMap'
import TrackPopup from '@/views/monitor/index/TrackPopup.vue'
import NewJlsStatusPan from '@/components/new-base/NewJlsStatusPan.vue'
import HelmetList from '@/views/monitor/index/HelmetList.vue'
import RealVideo from '@/views/monitor/index/RealVideo.vue'
import RealVideoSrs from '@/views/monitor/index/RealVideoSrs.vue'
import RealVideoMediasoup from '@/views/monitor/index/RealVideoMediasoup.vue'
import HealthChart from '@/components/new-base/HealthInfoChart.vue'

import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
// 依赖工具
import Overlay from 'ol/Overlay'
import { mapGetters } from 'vuex'
import {
  initMap,
  addElectricFenceLayer,
  addMutiHelmet,
  setMapCenter,
  getLocation,
  switchMapType,
  transformatPoint,
} from '@/common/map'
import { findDeviceNames, selectRecord } from '@/api/monitor'
import store from '@/store/index'
import { isLocalEnv, isSitEnv } from '@/util/common'
import { helmetInfo } from '@/api/log/operation'
import { setWaikeLeave } from '@/common/websocket/emergency'
import { closeVoiceCall } from '@/common/rtc/index'
import { networkSignal } from '@/util/networkSignal'
import { getTranscribe } from '@/api/personal'
import { setSession, nowDate, nextDate } from '@/api/common'

// 地图对象
let mapOl = null
// 头盔图层
let helmetVectorLayer = null
// 弹窗
let popup = null
// 弹窗dom
let popupContainer = null
export default {
  name: 'NewBase',
  components: {
    MHeader,
    MFooter,
    TrackController,
    TrailVideotape,
    IndoorMap,
    TrackPopup,
    NewJlsStatusPan,
    HelmetList,
    RealVideo,
    RealVideoSrs,
    RealVideoMediasoup,
    VueDraggableResizable,
    HealthChart,
  },
  provide() {
    return {
      openPiont: this.pointOpen,
    }
  },
  data() {
    return {
      width: 0,
      height: 0,
      x: 0,
      y: 0,
      allowDrag: true,
      dialogVisible: false,
      allowClick: false,
      reWrite: true,
      // 管控3窗口高度
      infoWindowHeight: 200,
      isStation: false,
      deviceName: '',
      onlinePersons: null,
      normalPan: true,
      show: false,
      // jls和gk3的弹窗开关做区别 解决轨迹播放时关不了弹窗的bug
      infoWindow: {
        show: false,
        gkShow: false,
        jlsShow: false,
      },
      // 撒点头盔列表
      helmetList: [],
      theme: '',
      zoom: 15,
      // 巨灵神设备0，安卓端设备1，执法仪2
      specType: '',
      // 轨迹相关
      showTrackController: false,
      trailVideoData: [],
      showVideo: false,
      // 是否展示录像图标
      showTrackVideo: false,
      listTrack: [],
      listTrackIndex: 0,
      trail: [],
      // 历史记录相关
      showHistoryRecord: false,
      // jls轨迹相关
      JlsTrailVisible: false,
      // 当前选中的头盔设备信息
      currentItem: {},
      // 头盔在线状态
      onlineStatus: '0',
      // 电子围栏列表展开flag
      isOpenFencePan: false,
      fenceData: {
        treedataList: [],
      },
      icons: [],
      showIcons: false,
      videoSecond: 0,
      // 点击轨迹的lng,lat
      spotLng: {},
      mapPlayTrail: [],
      stationList: [],
      topic: '',
      // 选中的jlsH5头盔信息
      jlsHelmet: null,
      mapType: 'street',
      // 其他页面跳转至精准调度页面
      isJump: false,
      themeMap: 'normal',
      // 室内地图组件是否展示
      indoorMapVisible: false,
      // 轨迹弹窗
      trackPopupInfo: {},
      // 告警数据
      tableData: [],
      battery: '',
      wifi: '',
      pressure: '-',
      envTemp: '-',
      laser: '',
      gps: '',
      mobile: '',
      flash: '',
      cam: '',
      // 是否背景图改变
      bgMainContain: false,
      // 设备在线 的连接网络情况
      onlineNetwork: false,
      // 卫星数量
      satellite: '',
      sateStatus: {
        chargStatus: '', //充电状态
        cidNum: '', // 卫星个数
        signal: '', // 信号强度
        freeBattery: '', // 剩余电量
      },
      // 信号强度图标
      signalIcon: require('@/icon/new-command/4G_off.png'),
      helmetItemInfo: {},
    }
  },
  computed: {
    ...mapGetters(['rtcType', 'isDefaultTheme', , 'showHeaderCollapse', 'showFootCollapse']),
    // 语音通话中监听
    waikIngInfo() {
      return this.$store.state.waikeInfo
    },
    // 语音通话中监听
    showWaike() {
      return this.$store.state.openWaike
    },
    waikeNormalClose() {
      return this.$store.state.waikeNormalClose
    },
    // 主题切换标识监听
    getTheme() {
      return this.$store.state.theme
    },
    isPlayTrail() {
      return store.state.isPlayTrail
    },
    trailData() {
      return store.state.trailData
    },
    trailQuery() {
      return store.state.trailQuery
    },
    trailPageNum() {
      return store.state.trailPageNum
    },
    trailTotal() {
      return store.state.trailTotal
    },
    trailIndexStore() {
      return store.state.trailIndex
    },
    ExitjlsHelmetInfo() {
      return this.$store.state.jlsHelmetInfo
    },
    jlstrailData() {
      return store.state.jlstrailData
    },
    jlstrailIndex() {
      return store.state.jlstrailIndex
    },
    jlsPlayTrack() {
      return store.state.jlsPlayTrack
    },
    helmetStatusObj() {
      return this.$store.state.helmetStatusObj
    },
    // 当前选中设备的状态值
    currentHelmetStatus() {
      if (this.helmetStatusObj && this.helmetStatusObj[this.currentItem.deviceName]) {
        return this.helmetStatusObj[this.currentItem.deviceName]
      } else {
        return {}
      }
    },
    isPlayTrack() {
      return this.$store.state.isPlayTrack
    },

    wifiIcon() {
      if (this.currentItem.onlineStatus === '0') {
        // 设备不在线 使用上一次的网络情况
        if (this.wifi) {
          return require('@/icon/new-command/WIFI_off.png')
        } else {
          return require('@/icon/new-command/4G_off.png')
        }
      } else {
        if (this.helmetStatusObj[this.currentItem.deviceName]) {
          // networkSignal === '0' 移动网络关闭
          if (
            this.helmetStatusObj[this.currentItem.deviceName].WIFI !== '0' &&
            this.helmetStatusObj[this.currentItem.deviceName].WIFI !== '-2' &&
            this.helmetStatusObj[this.currentItem.deviceName].WIFI !== '-1' &&
            this.helmetStatusObj[this.currentItem.deviceName].WIFI !== '-3'
          ) {
            this.onlineNetwork = true
            switch (this.helmetStatusObj[this.currentItem.deviceName].WIFI) {
              case '1':
                return require('@/icon/gk_WIFI_level1.png')
              case '2':
                return require('@/icon/gk_WIFI_level2.png')
              case '3':
                return require('@/icon/gk_WIFI_level3.png')
              case '4':
                return require('@/icon/gk_WIFI_level4.png')
              case '-2':
                return require('@/icon/WIFI00.png')
              case '-1':
                return require('@/icon/WIFI00.png')
              default:
                return require('@/icon/new-command/WIFI_off.png')
            }
          } else if (
            this.helmetStatusObj[this.currentItem.deviceName].phoneSign !== '0' &&
            this.helmetStatusObj[this.currentItem.deviceName].networkSignal
          ) {
            this.onlineNetwork = false
            if (this.currentItem.deviceName.indexOf('HWIH07') > -1) {
              return networkSignal('5', this.helmetStatusObj[this.currentItem.deviceName].networkSignal)
            } else {
              return networkSignal(this.helmetStatusObj[this.currentItem.deviceName].phoneSign, this.helmetStatusObj[this.currentItem.deviceName].networkSignal)
            }
          } else {
            return require('@/icon/new-command/WIFI_off.png')
          }
        }
        this.onlineNetwork = true
        return require('@/icon/new-command/WIFI_off.png')
      }
    },
    diveMode() {
      if (
        this.helmetStatusObj[this.currentItem.deviceName] &&
        this.helmetStatusObj[this.currentItem.deviceName].deviceMode === '3'
      ) {
        return true
      } else {
        return false
      }
    },
    powerIcon() {
      if (this.currentItem.onlineStatus === '0') {
        return require('@/icon/new-command/power_off.png')
      } else {
        return require('@/icon/new-command/power.png')
      }
    },
    pressureIcon() {
      if (this.currentItem.onlineStatus === '0') {
        return require('@/icon/new-command/pressure_off.png')
      } else {
        return require('@/icon/new-command/pressure.png')
      }
    },
    tempIcon() {
      if (this.currentItem.onlineStatus === '0') {
        return require('@/icon/new-command/temp_off.png')
      } else {
        return require('@/icon/new-command/temp.png')
      }
    },
    // 戴帽图标
    wearingIcon() {
      return require('@/icon/new-command/wearing.png')
    },
    // 脱帽图标
    wearingOffIcon() {
      return require('@/icon/new-command/wearing_off.png')
    },
    showHelmetTable() {
      return this.$store.state.showHelmetTable
    },
    // 实时视频中监听
    showRealeVideo() {
      return this.$store.state.openRealeVideo
    },
    // realVideoData
    realVideoData() {
      return this.$store.state.videoInfo
    },
    // formatDataItem
    formatDataItem() {
      return this.$store.state.videoItem
    },
  },
  watch: {
    formatDataItem: {
      handler: function(newVal) {
        if (newVal && newVal.specType) {
          this.allowClick = newVal.specType === 1 ? false : true
        }
      },
      deep: true,
    },
    // 显示全局视频组件
    showRealeVideo: {
      immediate: true,
      handler: function(newVal) {
        if (!newVal) {
          // 关闭视频时关闭操作允许
          this.allowClick = false
        }
      },
    },
    jlsPlayTrack(newVal) {
      if (newVal) {
        this.playJlsTrail()
      }
    },
    isPlayTrail(newVal) {
      if (newVal) {
        this.playTrail()
      } else {
        this.closeTrackController()
      }
    },
    showHelmetTable: {
      handler: function(val) {
        if (!val) {
          this.$store.commit('handleshowHelmetTable', false)
        }
      },
    },
    $route: {
      handler: function(val, oldVal) {
        // 跳转指挥台时 初始化页面
        if (val.name === 'command') {
          this.$store.commit('currentHelmetData', '')
          this.bgMainContain = true
          this.isJump = false
        } else {
          this.bgMainContain = false
          this.$store.commit('handleshowHelmetTable', false)

          if (this.listTrack) {
            // 轨迹打开时跳到其他页面关闭播放的轨迹
            this.closeTrackController()
          }
          clearInterval(this.pollInterval)
        }
      },
      // 深度观察监听
      deep: true,
    },
    // 切换主题监听
    getTheme(val) {
      this.theme = val
      this.reWrite = false
      this.$nextTick(() => {
        this.reWrite = true

        if (val === 'dark') {
          this.themeMap = 'midnight'
          switchMapType('satellite', mapOl)
          this.mapType = 'satellite'
        } else {
          this.themeMap = 'normal'
          switchMapType('street', mapOl)
          this.mapType = 'street'
        }
        // 清除头盔撒点图层
        helmetVectorLayer.getSource().clear()
        // 重新绘制撒点
        addMutiHelmet(helmetVectorLayer, this.helmetList, this.themeMap)
      })
    },
    waikIngInfo: {
      handler: function(val) {
        if (!this.waikeNormalClose && val.userList) {
          this.watchWaike(val)
        }
      },
      deep: true,
    },
    // 监听到组件NewWalkieCallingDialog里面的关闭事件，关闭浮窗
    waikeNormalClose: {
      handler(val) {
        if (val) {
          // this.signOutWaike()
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.getTranscribInfo()
    this._findDeviceNames(true)
    this.$nextTick(() => {
      this.loadMap()
    })
    this.$store.commit('changeVideoInfo', {})
    this.$store.commit('changeOpenVideo', false)
    this.$store.commit('openWaike', false)
    // 轮询刷新在线状态
    this.pollInterval = setInterval(() => {
      this._findDeviceNames()
    }, 10000)
    setWaikeLeave(this.signOutWaike)
    // 首次加载 如果是精准调度页面 去掉背景图
    if (this.$route.name === 'command') {
      this.bgMainContain = true
    }
    window.addEventListener('beforeunload', e => this.beforeunload(e))
  },
  destroyed() {
    // 页面离开时销毁定时器
    clearInterval(this.pollInterval)
    window.removeEventListener('beforeunload', e => this.beforeunload(e))
  },
  methods: {
    onResize: function(x, y, width, height) {
      this.x = x
      this.y = y
      this.width = width
      this.height = height
    },
    onDrag: function(x, y) {
      console.log(x, y)
      this.x = x
      this.y = y
    },
    // 获取设备信息
    getselectRecord() {
      let param = {
        deviceName: this.currentItem.deviceName,
        startTime: nowDate(),
        endTime: nextDate(),
        limit: 1,
        healthLimit: 1000,
      }
      selectRecord(param).then(res => {
        if (res.state === 0) {
          let baseStationPage = res.data.baseStationPage
          let deviceStatusPage = res.data.deviceStatusPage
          if (baseStationPage) {
            this.handleBaseStationPage(baseStationPage)
          }
          if (deviceStatusPage) {
            this.handleDeviceStatusPage(deviceStatusPage)
          }
        }
      })
    },
    handleBaseStationPage(data) {
      if (data && data[0]) {
        this.sateStatus.cidNum = data[0].cid
        this.sateStatus.signal = data[0].rss
        if (this.currentItem.onlineStatus === '1') {
          if (data[0].rss < 25) {
            // networkSignal('4', '1') 根据网络返回图标 ‘4’ 4G，‘1’信号格
            this.signalIcon = networkSignal('4', '1')
          } else if (25 < data[0].rss <= 50) {
            this.signalIcon = networkSignal('4', '2')
          } else if (50 < data[0].rss <= 75) {
            this.signalIcon = networkSignal('4', '3')
          } else if (75 < data[0].rss <= 100) {
            this.signalIcon = networkSignal('4', '4')
          } else {
            this.signalIcon = networkSignal('4', '0')
          }
        } else {
          this.signalIcon = require('@/icon/new-command/4G_off.png')
        }
      }
    },
    handleDeviceStatusPage(data) {
      if (data.length > 0) {
        this.sateStatus.chargStatus = data[0].chargingStatus

        this.sateStatus.freeBattery = data[0].freeBattery
      }
    },
    beforeunload() {
      this.$store.commit('handleshowHelmetTable', false)
      this.$store.commit('updatePlayTrail', false)
    },
    // 监听语音通话中是否有在通话中
    watchWaike(data) {
      let statusHelmet = []
      if (data.userList) {
        for (let item of data.userList) {
          statusHelmet.push(item.acceptCall)
        }
        setTimeout(() => {
          // '1': 通话中 具体请查看：对讲状态

          if (statusHelmet.indexOf('1') === -1) {
            this.$alert(this.$t('voiceCallEnded'), {
              confirmButtonText: this.$t('determine'),
              type: 'warning',
              closeOnClickModal: false,
            }).then(() => {
              this.signOutWaike()
            })
          }
        }, 200)
      } else {
        this.signOutWaike()
      }
    },
    // 直接关闭语音通话
    handleWaike() {
      this.$confirm(this.$t('sureCoseVoice') + '? ', {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        this.$store.commit('openWaike', false)
        console.log('直接关闭语音通话')
        this.$store.commit('waikeNormalClose', true)
        this.signOutWaike()
      })
    },
    signOutWaike() {
      closeVoiceCall(this.waikIngInfo, true)
    },
    loadMap() {
      // 地图风格
      let loctheme = localStorage.theme
      if (loctheme === 'dark') {
        this.themeMap = 'midnight'
        this.mapType = 'satellite'
      } else {
        this.themeMap = 'normal'
        this.mapType = 'street'
      }
      mapOl = initMap('mapNew')
      helmetVectorLayer = addElectricFenceLayer(mapOl) // 头盔撒点图层

      // 仅本地开发环境和测试环境加载室内定位地图
      if (isLocalEnv || isSitEnv) {
        // 室内地图图标入口
        let indoorVectorLayer = addElectricFenceLayer(mapOl)
        // 加载室内地图POI点
        loadIndoorMapPoi(indoorVectorLayer)
      }

      // 初始化地图弹窗
      popupContainer = document.getElementById('popup')
      popup = new Overlay({
        element: popupContainer,
        autoPan: true,
        autoPanAnimation: {
          duration: 250,
        },
      })
      mapOl.addOverlay(popup)

      this._findDeviceNames(true)
      // 鼠标移到图标上变成手势
      mapOl.on('pointermove', e => {
        let pixel = mapOl.getEventPixel(e.originalEvent)
        let hit = mapOl.hasFeatureAtPixel(pixel)
        mapOl.getTargetElement().style.cursor = hit ? 'pointer' : ''
      })
      mapOl.on('click', e => {
        //在点击时获取像素区域
        var pixel = mapOl.getEventPixel(e.originalEvent)
        // 事件顺序，数值越大，执行优先级越高
        let types = { helmet: 0, fence: 1, trackpoint: 2, indoormap: 3 }
        let typeIndex = -1
        let tempFeature = ''
        mapOl.forEachFeatureAtPixel(pixel, feature => {
          let type = feature.get('type')
          if (type === 'fence' && types['fence'] > typeIndex) {
            tempFeature = feature
            typeIndex = types['fence']
            // 通过id找到最新数据
          } else if (type === 'indoormap' && types['indoormap'] > typeIndex) {
            tempFeature = feature
            typeIndex = types['indoormap']
          } else if (type === 'trackpoint' && types['trackpoint'] > typeIndex) {
            tempFeature = feature
            typeIndex = types['trackpoint']
          } else {
            // 获取点的信息
            let helmet = feature.get('helmet')
            // 打开地图泡泡
            if (helmet && types['helmet'] > typeIndex) {
              tempFeature = feature
              typeIndex = types['helmet']
            }
          }
        })
        let data
        switch (typeIndex) {
          case 0:
            this.isOpen = true
            this.pointOpen(tempFeature.get('helmet'))
            break
          case 1:
            // 通过id找到最新数据
            data = this.fenceData.treedataList.find(o => o.id === tempFeature.getId())
            if (data) {
              this.openFenceInfo(data)
            }
            break
          case 2:
            this.trackPopupInfo = {
              lng: tempFeature.get('lng'),
              lat: tempFeature.get('lat'),
              specModel: this.currentItem.specModel,
              serialNumber: this.currentItem.serialNumber,
              userName: this.currentItem.userName,
              logTimestamp: tempFeature.get('logTimestamp'),
            }
            popupContainer.style.display = 'block'
            //设置overlay的显示位置
            popup.setPosition([tempFeature.get('lng'), tempFeature.get('lat')])
            break
          case 3:
            // 点击室内地图展示对应组件
            this.indoorMapVisible = true
            break
        }
      })
    },
    // 头盔面板展开
    pointOpen(item) {
      console.log('pointOpen', item)
      this.currentItem.showHealth = false
      // 每次点击都为中心
      if (item.position && item.position.lng && item.position.lat) {
        let center = {
          lng: item.position.lng,
          lat: item.position.lat,
        }
        setMapCenter(mapOl, center)
      }
      // 清空轨迹泡泡数据
      this.trackPopupInfo = {}
      // 非精准调度页面不打开面板
      if (this.isJump) {
        return
      }
      // 非精准调度界面会跳转至记至精准调度界面
      if (window.location.href.indexOf('newCommand') === -1) {
        this.$router.push({ path: '/newIndex/newCommand' })
        this.$store.commit('currentIndex', 'command')
        this.isJump = true
        return
      }
      // 有轨迹打开时关闭旧轨迹
      if (this.showTrackController) {
        this.closeTrackController()
      }
      // 关闭变电站点
      this.isStation = false
      // 其它资源窗口关闭
      this.closeHistoryRecord()
      this.closeJlsTrail()
      // 记录当前选中的头盔
      //设置弹出框内容，可以HTML自定义
      if (item['noBindDevice']) {
        // 把弹窗位置设置为undefined，并清空坐标数据
        popup.setPosition(undefined)
        document.getElementById('popup-closer').blur()
        // 清空轨迹泡泡数据
        this.trackPopupInfo = {}
        this.$store.commit('currentHelmetData', item)
        this.$store.commit('isPlayTrack', true)
      } else {
        this.$store.commit('currentHelmetData', item)
        this.currentItem = item
        if (item.specModel) {
          if (item.specModel.includes('HW-IH-0610') || item.specModel.includes('HW-IH-0611')) {
            this.currentItem.showHealth = true
          }
        }
        this.specType = item.specType
        if (!this.normalPan) {
          this.normalPan = true
        }
        popupContainer.style.display = 'block'
        //设置overlay的显示位置
        popup.setPosition(transformatPoint(item.position))
        if (item.specType !== 0) {
          // 获取电量信息等
          this.getHelmetInfo()
          // this.getselectRecord()
        }
        if (item.specType === 0 || item.specType === 4) {
          // 获取电量信息等
          this.getHelmetInfo()
          this.getselectRecord()
        }
        if (item.position && item.position.lng && item.position.lat) {
          // 地址逆解析
          getLocation(item.position.lng, item.position.lat, address => {
            this.$set(this.currentItem, 'positionName', address)
          })
        }
      }
    },
    getHelmetInfo() {
      if (!this.currentItem || !this.currentItem.userId || this.currentItem.userId === 'undefined') {
        return
      }
      this.envTemp = '-'
      this.pressure = '-'
      helmetInfo(this.currentItem.userId).then(res => {
        if (res.state === 0 && res.value) {
          this.helmetItemInfo = res.value
          this.battery = res.value && res.value.battery ? res.value.battery.split('.')[0] + '%' : ''
          this.wifi = res.value.wifi
          this.envTemp =
            res.value.logExtraDataDto && res.value.logExtraDataDto.envTemp
              ? res.value.logExtraDataDto.envTemp + '℃'
              : '-'
          this.pressure =
            res.value.logExtraDataDto && res.value.logExtraDataDto.pressure
              ? this.formatPressure(res.value.logExtraDataDto.pressure)
              : '-'
        }
      })
    },
    formatPressure(value) {
      let res = (Number(value) / 10).toFixed(1)
      return res
    },
    closePopup() {
      // 把弹窗位置设置为undefined，并清空坐标数据
      popup.setPosition(undefined)
      document.getElementById('popup-closer').blur()
      // 清空轨迹泡泡数据
      this.trackPopupInfo = {}
      return false
    },
    changeTableData(val) {
      this.tableData = val
    },
    // 查询地图上全部可展示设备序列号列表
    _findDeviceNames(firstflag) {
      let param = [0, 1]
      findDeviceNames(param).then(res => {
        if (res.state === 0) {
          // 获取初始第一个安全帽位置,播放轨迹时，不刷新
          if (this.trail.length === 0) {
            if (res.data[0]) {
              if (firstflag) {
                // 等待地图加载后再设置中心点
                setMapCenter(mapOl, res.data[0].position)
              }
            }
            // }
            this.findDeviceNamesFlag = true
            // 根据在线状态排序=>在地图上显示在线的在前
            res.data.sort((a, b) => {
              return a.onlineStatus - b.onlineStatus
            })
            // 查找全部点位置信息
            this.helmetList = res.data
            // 清除头盔撒点图层
            helmetVectorLayer.getSource().clear()
            addMutiHelmet(helmetVectorLayer, this.helmetList, this.themeMap)
          }
        }
      })
    },
    // 关闭历史记录弹窗
    closeHistoryRecord() {
      this.showHistoryRecord = false
    },
    // 关闭jls轨迹弹窗
    closeJlsTrail() {
      this.JlsTrailVisible = false
    },
    // 弹窗关闭事件 jls和gk3的
    infoWindowClose() {
      this.infoWindowHeight = 200
      this.infoWindow.show = false
      this.trackPopupInfo = {}
    },
    infoWindowGkClose() {
      this.infoWindowHeight = 200
      this.infoWindow.gkShow = false
      this.closePopup()
    },
    infoWindowjlsClose() {
      this.infoWindowHeight = 200
      this.infoWindow.jlsShow = false
      this.closePopup()
    },
    // 点击历史记录弹窗 播放轨迹 按钮事件
    playTrail() {
      this.showTrackController = true
      this.showIcons = true
      this.listTrack = this.trailData
      this.listTrackIndex = this.trailIndexStore
      this.trail = []
      mapOl.getView().setZoom(17)
      // 修改图层显示地图播放轨迹
      let mainBox = document.getElementsByClassName('mainContain')
      mainBox[0].style.zIndex = 0
    },
    // 点击jls轨迹弹窗 播放轨迹 按钮事件
    playJlsTrail(data, index) {
      this.showTrackController = true
      this.showIcons = true
      this.listTrack = this.jlstrailData
      this.listTrackIndex = this.jlstrailIndex
      this.currentItem = this.ExitjlsHelmetInfo
      this.trail = []
    },
    // 关闭播放轨迹窗口
    closeTrackController() {
      // 清空轨迹泡泡数据
      let mainBox = document.getElementsByClassName('mainContain')
      if (mainBox && mainBox[0]) {
        mainBox[0].style.zIndex = 99
      }

      this.trackPopupInfo = {}
      this.showTrackController = false
      if (this.currentItem) {
        store.commit('ExitJlsTrailIndex', 0)
        // 关闭 轨迹控制器显示历史弹窗 (根据specType判断是JLS还是二郎神的设备)
        if (this.currentItem.specType === 0) {
          store.commit('jlsTrackList', true)
        }
      }
    },
    // 轨迹开始绘制事件 - 清空弹窗
    drawTrackStart() {
      // 同时关闭设备详情弹窗
      this.infoWindowGkClose()
      this.infoWindowjlsClose()
      this.trackPopupInfo = {}
    },
    // 关闭轨迹录像播放，轨迹控制器正常使用
    trailVideo() {
      this.showTrackVideo = true
    },
    //开启轨迹视频
    openTrackVideo(val, showVideo, secondTime) {
      this.trailVideoData = val
      this.showVideo = showVideo
      this.videoSecond = secondTime
      this.showTrackVideo = false
    },
    // 切换地图类型
    switchMapType(type) {
      this.mapType = type
      // 切换地图类型 设置最大层级
      if (type === 'street') {
        switchMapType('street', mapOl)
        mapOl.getView().setMaxZoom(19)
      } else {
        switchMapType('satellite', mapOl)
        mapOl.getView().setMaxZoom(18)
      }
    },
    // 安全帽面板展开
    choosePointOpen(userId) {
      if (this.helmetList) {
        let helmet = this.helmetList.filter(h => h.userId === userId)
        if (helmet && helmet[0]) {
          this.pointOpen(helmet[0])
        }
      }
    },
    // 获取租户直播、实时视频录制配置
    getTranscribInfo() {
      getTranscribe().then(res => {
        if (res.state === 0) {
          if (res.data) {
            for (let item of res.data) {
              if (item.transcribe === 'TRANSCRIBE_REAL_VIDEO') {
                setSession('TRANSCRIBE_REAL_VIDEO', item.value)
              }
              if (item.transcribe === 'TRANSCRIBE_LIVE') {
                setSession('TRANSCRIBE_LIVE', item.value)
              }
              if (item.transcribe === 'TRANSCRIBE_LIVE_MODE') {
                this.$store.commit('changeLiveMode', item.value)
              }
            }
          }
        }
      })
    },
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
@import '~@/style/popup-ol.styl'
.el-main
  padding 0!important
  height calc(100% - 30px);/*no*/
  overflow: hidden
  position: relative
  bg-image('~@/icon/re-new-header/bg.png')
  .mainMonitor
    height calc(100% - 76px)
    margin 0 20px
    border-radius: 4px;
    position relative
    .maskbg
      height 250px
      width 100%
      position absolute
      bottom 0
      pointer-events: none;
      bg-image('~@/icon/new-command/whitebg.png')
    .mainContain
      position absolute
      top:0px;
      left: 0;
      right: 0;
      bottom: 0;
      //外层元素禁止点击事件
      pointer-events: none;
      background: #fff;
      z-index: 99
      height 100%
    .bgMainContain
      background: none;

    .map-switch
      position: absolute;
      background: white;
      z-index: 1;
      cursor: pointer;
      border-radius: 2px;
      overflow: hidden;
      left: 420px;
      top: 80px;
      div
        box-shadow: rgb(0 0 0 / 35%) 2px 2px 3px;
        border-width: 1px;
        border-style: solid;
        border-color: rgb(139, 164, 220);
        background: rgb(255, 255, 255);
        padding: 2px 6px;
        font-style: normal;
        font-variant: normal;
        font-stretch: normal;
        font-size: 12px;
        line-height: 1.3em;
        font-family: arial, sans-serif;
        text-align: center;
        white-space: nowrap;
        color: rgb(0, 0, 0);
        float left
        &.active
          box-shadow: rgb(0 0 0 / 35%) 2px 2px 3px;
          border-left: 1px solid rgb(139, 164, 220);
          border-top: 1px solid rgb(139, 164, 220);
          border-bottom: 1px solid rgb(139, 164, 220);
          background: rgb(142, 168, 224);
          padding: 2px 6px;
          font: bold 12px / 1.3em arial, sans-serif;
          text-align: center;
          white-space: nowrap;
          color: rgb(255, 255, 255);
  .allMain
    height 100%
  .hidencollapseHead
    height 100%
  .hidencollapseFoot
    height calc(100% - 76px)
  .showHelmetTable
    height 61%
    #mapNew
      .mainContain
        .mainMonitor
          height 100%
.collapseMain
  height 100%
.collapseHead
  height calc(100% - 30px)
.collapseFoot
  height 100%
.close-yuyin
  position: absolute
  top 100px
  right 50px
  width 280px
  color #999999
  font-weight: 600
  z-index 99999
  background: #FFFFFF;
  box-shadow: 0px 3px 4px 0px rgba(0,0,0,0.1);
  border-radius: 4px;
  padding 10px 12px
  p
    display inline
    color #0E65DD
    font-size: 18px
    line-height 42px
    .voice-icon
      width 30px
      height 30px
      vertical-align: middle
      margin 0 8px
    span
      font-size: 18px
  .dot
    font-family: simsun;
    animation: dot 3s infinite step-start;
  .close-btn
    float right
    height: 36px;
    line-height: 36px;
    font-size: 15px
    padding 0 8px
    background: #FFFFFF;
    border: 1px solid #D1DAE7;
    border-radius: 4px;
    cursor pointer
    margin 0 8px
@keyframes dot
  0%
    width 0
    margin-right 1.5em
  33%
    width .5em
    margin-right: 1em
  66%
    width: 1em
    margin-right: .5em
  100%
    width: 1.5em
    margin-right: 0

:root .dot
  display: inline-block
  width: 1.5em
  vertical-align: bottom
  overflow: hidden
// 室内地图相关样式
.indoor-map-container ::v-deep
  .el-dialog
    margin-top 110px !important
    width 1158px
    height 772px
    border-radius 0
    .el-dialog__header
      padding 0
    .el-dialog__body
      height calc(100% - 40px)
      padding 0
      overflow auto
.record
  position relative
.title_box
  width 230px
  background url('~@/icon/newBg/title_bg.png')no-repeat
  background-size: 100% 100%;
  -webkit-background-size: 100% 100%;

  .new_title
    width 100%
    height 46px
    line-height 46px
    padding-left 56px
    font-size: 18px;
    color #0E65DD
    font-weight: bold
#popup
  #popup-content
    .helmetStatus
      pointer-events: auto
      padding-bottom: 0px
      .titleblock
        height 27px
        padding-top 10px
        font-weight bold
        display flex
        .user
          font-size: 14px;
          font-weight: bold;
          color: #0E65DD;
          margin-left: 14px
        .model
          font-size: 12px;
          color: #409eff;
          margin-left: 14px
          border-radius: 10px
          font-weight: 400;
        .close
          cursor pointer
          width 16px
          height: 16px
          float: right;
          margin-right: 14px
          bg-image('~@/icon/new-command/ic_cancle.png')
      .content
        margin-top: 10px
        margin-left: 15px;
        margin-right 15px
        .time-alarm
          display: flex
          .item-time
            width 60%
          .item-alarm
            width 40%
        .contend-right
          // width: 43%;
          display: flex
          // justify-content: space-between;
          margin-right 14px
          margin-top: 20px
          div
            width 25%
          .icon-right
            display: flex
            justify-content: space-around;
            margin-top: 10px;
            img
              width 30px
              height 30px
            &:last-child
              margin-top: 10px
          span
            font-size 12px
        .contend-ps
          display: flex
          justify-content: space-around;
          margin-top 14px
    .helmetStatusOff
      pointer-events: auto
      // padding-bottom: 30px
      .titleblock
        height 27px
        padding-top 10px
        font-weight bold
        display flex
        .user
          font-size: 14px;
          font-weight: bold;
          color: #333;
          margin-left: 14px
        .close
          cursor pointer
          width 16px
          height: 16px
          float: right;
          margin-right: 14px
          bg-image('~@/icon/new-command/ic_cancle.png')
      .content
        margin-top: 10px
        margin-left: 15px;
        .time-alarm
          display: flex
          .item-time
            width 60%
          .item-alarm
            width 40%
        .contend-right
          // width: 43%;
          display: flex
          // justify-content: space-between;
          margin-right 14px
          margin-top: 20px
          div
            width 25%
          .icon-right
            display: flex
            justify-content: space-around;
            img
              width 30px
              height 30px
            &:last-child
              margin-top: 10px;
          span
            font-size 12px
.base-box
  background #fff
  position fixed
  border: 1px solid rgba(0, 222, 255, 0.5);
  z-index: 2919
  #amplifyVideo
    pointer-events: auto
    background #fff
    position fixed
    left: 28%
    top: 45%
    width 520px
    border: 1px solid rgba(0, 222, 255, 0.5)
    z-index: 9999
  .reaVideo-box
    width 100%
    height 100%
// 深色样式
.theme-dark
  .close-yuyin
    color #00DEFF
    background: #172f7a;
    border: 1px solid #16D0FF;
    p
      color #fff
    .close-btn
      background: #00113C;
      border: 1px solid #0057A8;
  #popup
    #popup-content
      .helmetStatus
        .titleblock
          .user
            color #00E4FF;
      .helmetStatusOff
        .titleblock
          .user
            color #ccc;
  .el-main
    bg-image('~@/icon/re-new-header/bg-m.png')
    .maskbg
      bg-image('~@/icon/new-command/darkbg.png')
    .mainMonitor
      .mainContain
        background: #001143;
      .bgMainContain
        background: none;
  .title_box
    .new_title
      color var(--title-color)
</style>
